// src/pages/Home.js
import React from 'react';
import NotFound from '../HomeComponents/NotFound'; 
import Navbar from '../HomeComponents/Navbar'; 
function Home() {
  return (
    <div>
        <NotFound/>
    </div>
  );
}

export default Home;